import React from 'react';
const BreadcrumbContext = React.createContext({
    depth: 0,
});
export default BreadcrumbContext;
